module.exports = __webpack_public_path__ + "img/11.da8e0aea.png";